import * as React from 'react';
import { useEffect, useState } from 'react';
import useFetch from 'use-http';
import Dialog from 'src/components/common/Dialog';
import Button from 'src/components/controls/forms/redesign/FormButton';
import LoadingSpinner from 'src/components/common/LoadingSpinner';
import TeNonReconChangeDetail from '../models/TeNonReconChangeDetail';

interface IChangeDetailDialogProps {
    dialogName: string;
    hideDialog: () => void;
    tmId?: number;
}

const formatTimestamp = (value: string): string => {
    if (!value) {
        return '';
    }
    const date = new Date(value);
    return isNaN(date.getTime()) ? '' : date.toLocaleString();
};

// Mirrors TIME_SHEET_CHANGE_DETAIL (oid 409, canvas/window CHANGE_DETAIL) - the change-history
// drill-down reached by double-clicking a Modified Time Records row (WHEN-MOUSE-DOUBLECLICK, oid
// 369). B_BACK [oid ~432] just closes it (Go_Block('Time_Sheet_Change_Records');
// Hide_Window('Change_Detail')) - no edit capability here, purely a read-only audit view.
const ChangeDetailDialog = (props: IChangeDetailDialogProps) => {
    const { get, response } = useFetch();
    const [changes, setChanges] = useState<Array<TeNonReconChangeDetail>>([]);
    const [loading, setLoading] = useState<boolean>(false);

    useEffect(() => {
        if (!props.tmId) {
            setChanges([]);
            return;
        }
        setLoading(true);
        get(`/v1.0/AccountsPayable/timeandexpense/nonrecon/changedetail/${props.tmId}`).then((result) => {
            setChanges(response.ok && Array.isArray(result) ? result : []);
            setLoading(false);
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.tmId]);

    return (
        <Dialog title="Change History" dialogName={props.dialogName} isExitButtonInvisible={true} bodyStyle={{ width: '45%' }}>
            <table style={{ width: '100%' }}>
                <thead style={{ textAlign: 'center' }}>
                    <tr>
                        <th>Field</th>
                        <th>Old Value</th>
                        <th>New Value</th>
                        <th>Modified By</th>
                        <th>Timestamp</th>
                    </tr>
                </thead>
                <tbody>
                    {loading && (
                        <tr>
                            <td colSpan={5} className="bold-centered">
                                <LoadingSpinner />
                            </td>
                        </tr>
                    )}
                    {!loading && changes.map((change) => (
                        <tr key={change.id} style={{ textAlign: 'center' }}>
                            <td>{change.displayName}</td>
                            <td>{change.oldValue}</td>
                            <td>{change.newValue}</td>
                            <td>{change.modBy}</td>
                            <td>{formatTimestamp(change.timestamp)}</td>
                        </tr>
                    ))}
                    {!loading && changes.length === 0 && (
                        <tr><td colSpan={5} className="bold-centered">No Changes Found</td></tr>
                    )}
                </tbody>
            </table>
            <div className="form-row" style={{ marginTop: '1rem', justifyContent: 'center' }}>
                <Button className="blue-hover-button" style={{ width: '25%' }} text="OK" onClick={() => props.hideDialog()} />
            </div>
        </Dialog>
    );
};

export default ChangeDetailDialog;



// WEBPACK FOOTER //
// ./src/components/project-billing/dialogs/ChangeDetailDialog.tsx